import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import isEmpty from 'lodash/isEmpty'
import cloneDeep from 'lodash/cloneDeep'

import { getGeoJson } from '../../actions/viewerActions'
import Loading from '../../components/loading'
import { makeStyles } from '@mui/styles'
import Box from '@mui/material/Box'
import { Fab } from '@mui/material'
import Icon from '@mui/material/Icon'
import { useParams } from 'react-router-dom'

export const useStyles = makeStyles((theme) => ({
  viewerContent: {
    position: 'relative',
    height: '100vh'
  },
  viewerControls: {
    position: 'absolute',
    zIndex: 1,
    right: 0,
    top: 0,
    width: 'auto !important',
    height: 'auto !important'
  }
}))

// eslint-disable-next-line react/prop-types
export default function UseViewer ({ onCallbackClick }) {
  const { id } = useParams()

  const classes = useStyles()
  const [showBuildings, setShowBuildings] = useState(true)
  const [loading, setLoading] = useState(false)
  const dispatch = useDispatch()
  const geoJSONStore = useSelector(state => state.viewer.geoJson)
  const feature = useSelector(state => state.viewer.feature)

  const hiddenBuildingLayer = () => {
    setShowBuildings(false)
    window.useViewer.hiddenBuildingsLayer()
  }
  const showBuildingLayer = () => {
    setShowBuildings(true)
    window.useViewer.showBuildingsLayer()
  }
  const mapRotate = (orientation) => {
    window.useViewer.mapRotate(orientation)
  }
  const onLoadMap = () => {
    setLoading(false)
  }

  const generateCanvas = () => {
    if (!isEmpty(geoJSONStore)) {
      const geoJson = cloneDeep(geoJSONStore)
      const Viewer = window.viewer
      window.useViewer = new Viewer('yyg32322', geoJson, onCallbackClick, null, null, feature, onLoadMap)
      const viewer = window.useViewer
      viewer.render('myCanvas')
    }
  }

  useEffect(() => {
    dispatch(getGeoJson(id))
    setLoading(true)
  }, [])

  useEffect(() => {
    generateCanvas()
  }, [JSON.stringify(geoJSONStore)])

  return (
        <div className={classes.viewerContent}>
            <Loading open={loading} type="circular"/>
            <div className={classes.viewerControls}>
                <Box sx={{ '& > :not(style)': { m: 1 } }}>
                    {showBuildings &&
                    <Fab aria-label="add" onClick={() => hiddenBuildingLayer()}>
                        <Icon>grid_off</Icon>
                    </Fab>
                    }
                    {!showBuildings &&
                    <Fab aria-label="edit" onClick={() => showBuildingLayer()}>
                        <Icon>grid_on</Icon>
                    </Fab>
                    }
                    <Fab aria-label="like" onClick={() => mapRotate('left')}>
                                   <Icon>rotate_right</Icon>
                    </Fab>

                    <Fab aria-label="like" onClick={() => mapRotate('right')}>
                        <Icon>rotate_left</Icon>
                    </Fab>
                </Box>
            </div>
            <div id="myCanvas"/>
        </div>
  )
}
